import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div
            className="flex items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src="https://customer-assets.emergentagent.com/job_3ea62174-d58f-4d0c-8b73-d8433d550e0e/artifacts/1goande0_IMG_1273.png"
              alt="Agente 360"
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#servicios"
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors duration-200"
            >
              Tours
            </a>
            <a
              href="#destinos"
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors duration-200"
            >
              Destinos
            </a>
            <a
              href="#testimonios"
              className="text-gray-700 hover:text-yellow-600 font-medium transition-colors duration-200"
            >
              Testimonios
            </a>
            <Button
              onClick={() => navigate("/consulta")}
              className="bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-gray-900 font-semibold px-6 shadow-lg transition-all duration-300 hover:shadow-xl"
            >
              Reservar Tour
            </Button>
          </div>

          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-6 space-y-4">
            <a
              href="#servicios"
              className="block text-gray-700 hover:text-yellow-600 font-medium py-2 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Tours
            </a>
            <a
              href="#destinos"
              className="block text-gray-700 hover:text-yellow-600 font-medium py-2 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Destinos
            </a>
            <a
              href="#testimonios"
              className="block text-gray-700 hover:text-yellow-600 font-medium py-2 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Testimonios
            </a>
            <Button
              onClick={() => {
                navigate("/consulta");
                setIsMobileMenuOpen(false);
              }}
              className="w-full bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-gray-900 font-semibold shadow-lg"
            >
              Reservar Tour
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
